import { Container } from 'react-bootstrap';
import '../../css/Content.css';
import 'bootstrap/dist/css/bootstrap.min.css'

export const Page16 = () => {




  return (
    <>      
      <section>   

      <div className='container'>

        <div style={{ paddinBottom: "80px"}}>  

          <div style={{height: '85vh', display: 'flex', alignItems: 'center', color: '#ffffff'}}>
            <div>
              <p>
                O Gerenciamento de mudanças (MOC) não se limita à necessidade operacional. Ele é sustentado por exigências legais, pela gestão de riscos e por uma estrutura que organiza como os processos devem funcionar.
              </p>
              <p>
                Esse contexto é o que permite transformar diretrizes e requisitos em ações consistentes no dia a dia da operação.
              </p>
              <p>
                A seguir, vamos explorar os <strong>papéis e responsabilidades</strong> envolvidos no MOC e como cada envolvido contribui para que o processo funcione de forma segura e estruturada. 
              </p>     
              <p><strong>Vamos lá?</strong></p>              
            </div>
          </div>         

        </div>
        
      </div>

      </section>
    </>
  );
};

export default Page16;